import { atom } from 'recoil';

export const isRatingRefreshAtom = atom({
  key: 'isRatingRefreshAtom',
  default: false,
});
